import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatContext } from '../../context/ChatContext';
import ChatSidebar from './ChatSidebar';
import ChatRoom from './ChatRoom';
import CreateChatModal from './CreateChatModal';
import '../../styles/Chat.css';

const ChatPage = ({ userId, userRole, schoolId }) => {
    const { t } = useTranslation('chat');
    const { activeChatRoom, closeChatRoom } = useContext(ChatContext);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createChatType, setCreateChatType] = useState(null);

    const isTrainer = userRole === 'ROLE_TRAINER';

    const handleCreateChat = (type) => {
        setCreateChatType(type);
        setShowCreateModal(true);
    };

    const handleBackToList = () => {
        closeChatRoom();
    };

    return (
        <div className="chat-page">
            <div className={`chat-sidebar-container ${activeChatRoom ? 'hide-mobile' : ''}`}>
                <ChatSidebar
                    onCreateChat={handleCreateChat}
                    isTrainer={isTrainer}
                    userId={userId}
                />
            </div>

            <div className={`chat-main-container ${!activeChatRoom ? 'hide-mobile' : ''}`}>
                {activeChatRoom ? (
                    <ChatRoom
                        userId={userId}
                        isTrainer={isTrainer}
                        schoolId={schoolId}
                        onBack={handleBackToList}
                    />
                ) : (
                    <div className="chat-empty-state">
                        <div className="chat-empty-icon">💬</div>
                        <h3>{t('selectChat')}</h3>
                        <p>{t('selectChatDesc')}</p>
                    </div>
                )}
            </div>

            {showCreateModal && (
                <CreateChatModal
                    type={createChatType}
                    schoolId={schoolId}
                    userRole={userRole}
                    userId={userId}
                    onClose={() => {
                        setShowCreateModal(false);
                        setCreateChatType(null);
                    }}
                />
            )}
        </div>
    );
};

export default ChatPage;
